
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/medical-card/florida",
      function () {
        return require("private-next-pages/medical-card/florida/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/medical-card/florida"])
      });
    }
  